import pathToRegexp from 'path-to-regexp'

import Market from '@/views/Markets/Market'
import Contact from '@/views/Contact/'
import Page404 from '@/views/Page404/'
import Page from '@/views/Page'
import ProjectPage from '@/views/Projects/ProjectPage'
import StoryPage from '@/views/Story/index'
import TechnicalGuide from '@/views/TechnicalGuide/index'
import SitemapPage from '@/views/Sitemap/index'
// import AboutPage from '@/views/About/index'
export const LANGUAGES = ['fr', 'en', 'es']
const localeLabel = ':locale(' + LANGUAGES.join('|') + ')'
const getLocale = () => {
    const userLang = (navigator.language || navigator.userLanguage)
        .toLowerCase()
        .substring(0, 2)

    const id = LANGUAGES.indexOf(userLang)
    return id > -1 ? LANGUAGES[id] : LANGUAGES[0]
}

export let routes = [{
        name: 'Home',
        path: '/' + localeLabel,
        component: Page,
        meta: {
            page: 'home',
            localeRoutes: {
                en: '/en',
                fr: '/fr',
                es: '/es'
            }
        }
    },
    {
        name: 'About',
        path: '/' + localeLabel + '/about',
        alias: [
            '/' + localeLabel + '/a-propos',
            '/' + localeLabel + '/quienes-somos'
        ],
        component: Page,
        meta: {
            page: 'about',
            breadcrumb: [{
                i18n: 'nav.about',
                name: 'About'
            }],
            localeRoutes: {
                en: '/en/about',
                fr: '/fr/a-propos',
                es: '/es/quienes-somos'
            }
        }
    },
    {
        name: 'Direction',
        path: '/' + localeLabel + '/leadership',
        alias: [
            '/' + localeLabel + '/direction',
            '/' + localeLabel + '/direccion'
        ],
        component: Page,
        meta: {
            page: 'direction',
            breadcrumb: [{
                    i18n: 'nav.about',
                    name: 'About'
                },
                {
                    i18n: 'nav.direction',
                    name: 'Direction'
                }
            ],
            localeRoutes: {
                en: '/en/leadership',
                fr: '/fr/direction',
                es: '/es/direccion'
            }
        }
    },
    {
        name: 'Innovation',
        path: '/' + localeLabel + '/about/innovation',
        alias: [
            '/' + localeLabel + '/a-propos/innovation',
            '/' + localeLabel + '/quienes-somos/innovacion'
        ],
        component: Page,
        meta: {
            page: 'innovation',
            breadcrumb: [{
                    i18n: 'nav.about',
                    name: 'About'
                },
                {
                    i18n: 'nav.innovation',
                    name: 'Innovation'
                }
            ],
            localeRoutes: {
                en: '/en/about/innovation',
                fr: '/fr/a-propos/innovation',
                es: '/es/quienes-somos/innovacion'
            }
        }
    },
    {
        name: 'Solutions',
        path: '/' + localeLabel + '/solutions',
        alias: [
            '/' + localeLabel + '/soluciones'
        ],
        component: Page,
        meta: {
            page: 'solutions',
            breadcrumb: [{
                i18n: 'nav.solutions',
                name: 'Solutions'
            }],
            localeRoutes: {
                en: '/en/solutions',
                fr: '/fr/solutions',
                es: '/es/soluciones'
            }
        }
    },
    {
        name: 'Markets',
        path: '/' + localeLabel + '/solutions/markets',
        alias: [
            '/' + localeLabel + '/solutions/marches',
            '/' + localeLabel + '/soluciones/mercados'
        ],
        component: Page,
        meta: {
            id: 'markets',
            page: 'markets',
            breadcrumb: [{
                    i18n: 'nav.solutions',
                    name: 'Solutions'
                },
                {
                    i18n: 'nav.markets',
                    name: 'Markets'
                }
            ],
            localeRoutes: {
                en: '/en/solutions/markets',
                fr: '/fr/solutions/marches',
                es: '/es/soluciones/mercados'
            }
        },
        children: [{
            name: 'Market',
            path: ':slug',
            component: Market,
            meta: {
                id: 'markets',
                type: 'market',
                page: 'markets',
                breadcrumb: [{
                        i18n: 'nav.solutions',
                        name: 'Solutions'
                    },
                    {
                        i18n: 'nav.markets',
                        name: 'Markets'
                    },
                    {
                        query: 'name',
                        name: 'Markets'
                    }
                ],
                localeRoutes: {
                    en: '/en/solutions/markets/:slug',
                    fr: '/fr/solutions/marches/:slug',
                    es: '/es/soluciones/mercados/:slug'
                }
            }
        }]
    },
    {
        name: 'Techniques',
        path: '/' + localeLabel + '/solutions/techniques',
        alias: [
            '/' + localeLabel + '/soluciones/tecnicas'
        ],
        component: Page,
        meta: {
            page: 'techniques',
            breadcrumb: [{
                    i18n: 'nav.solutions',
                    name: 'Solutions'
                },
                {
                    i18n: 'nav.techniques',
                    name: 'Techniques'
                }
            ],
            localeRoutes: {
                en: '/en/solutions/techniques',
                fr: '/fr/solutions/techniques',
                es: '/es/soluciones/tecnicas'
            }
        }
    },
    {
        name: 'Technique',
        path: '/' + localeLabel + '/solutions/techniques/:slug',
        alias: [
            '/' + localeLabel + '/soluciones/tecnicas/:slug'
        ],
        component: ProjectPage,
        meta: {
            type: 'technique',
            breadcrumb: [{
                    i18n: 'nav.solutions',
                    name: 'Solutions'
                },
                {
                    i18n: 'nav.techniques',
                    name: 'Techniques'
                },
                {
                    query: 'name',
                    name: 'Techniques'
                }
            ],
            localeRoutes: {
                en: '/en/solutions/techniques/:slug',
                fr: '/fr/solutions/techniques/:slug',
                es: '/es/soluciones/tecnicas/:slug'
            }
        }
    },
    {
        name: 'Method',
        path: '/' + localeLabel + '/solutions/techniques/:technique/:slug',
        alias: [
            '/' + localeLabel + '/soluciones/tecnicas/:technique/:slug'
        ],
        component: ProjectPage,
        meta: {
            type: 'method',
            queryBread: [{
                type: 'technique'
            }],
            breadcrumb: [{
                    i18n: 'nav.solutions',
                    name: 'Solutions'
                },
                {
                    i18n: 'nav.techniques',
                    name: 'Techniques'
                },
                {
                    subquery: 'name',
                    type: 'technique',
                    name: 'Technique'
                },
                {
                    query: 'name',
                    name: 'Method'
                }
            ],
            localeRoutes: {
                en: '/en/solutions/techniques/:technique/:slug',
                fr: '/fr/solutions/techniques/:technique/:slug',
                es: '/es/soluciones/tecnicas/:technique/:slug'
            }
        }
    },
    {
        name: 'Projects',
        path: '/' + localeLabel + '/projects',
        alias: [
            '/' + localeLabel + '/realisations',
            '/' + localeLabel + '/proyectos'
        ],
        component: Page,
        meta: {
            page: 'projects',
            breadcrumb: [{
                i18n: 'nav.projects',
                name: 'Projects'
            }],
            localeRoutes: {
                en: '/en/projects',
                fr: '/fr/realisations',
                es: '/es/proyectos'
            }
        }
    },
    {
        name: 'Project',
        path: '/' + localeLabel + '/projects/:slug',
        alias: [
            '/' + localeLabel + '/realisations/:slug',
            '/' + localeLabel + '/proyectos/:slug'
        ],
        component: ProjectPage,
        meta: {
            type: 'project',
            breadcrumb: [{
                    i18n: 'nav.projects',
                    name: 'Projects'
                },
                {
                    query: 'name',
                    name: 'Projects'
                }
            ],
            localeRoutes: {
                en: '/en/projects/:slug',
                fr: '/fr/realisations/:slug',
                es: '/es/proyectos/:slug'
            }
        }
    },
    {
        name: 'Joinus',
        path: '/' + localeLabel + '/join-us',
        alias: [
            '/' + localeLabel + '/joinus',
            '/' + localeLabel + '/nous-rejoindre',
            '/' + localeLabel + '/unase-a-nosotros'
        ],
        component: Page,
        meta: {
            page: 'joinus',
            breadcrumb: [{
                i18n: 'nav.joinus',
                name: 'Joinus'
            }],
            localeRoutes: {
                en: '/en/join-us',
                fr: '/fr/nous-rejoindre',
                es: '/es/unase-a-nosotros'
            }
        }
    },
    {
        name: 'News',
        path: '/' + localeLabel + '/news',
        alias: [
            '/' + localeLabel + '/actualites',
            '/' + localeLabel + '/noticias'
        ],
        component: Page,
        meta: {
            page: 'news',
            breadcrumb: [{
                i18n: 'nav.news',
                name: 'News'
            }],
            localeRoutes: {
                en: '/en/news',
                fr: '/fr/actualites',
                es: '/es/noticias'
            }
        }
    },
    {
        name: 'Article',
        path: '/' + localeLabel + '/news/:slug',
        alias: [
            '/' + localeLabel + '/actualites/:slug',
            '/' + localeLabel + '/noticias/:slug'
        ],
        component: StoryPage,
        meta: {
            type: 'story',
            breadcrumb: [{
                    i18n: 'nav.news',
                    name: 'News'
                },
                {
                    query: 'name',
                    name: 'News'
                }
            ],
            localeRoutes: {
                en: '/en/news/:slug',
                fr: '/fr/actualites/:slug',
                es: '/es/noticias/:slug'
            }
        }
    },
    {
        name: 'Contact',
        path: '/' + localeLabel + '/contact',
        alias: [
            '/' + localeLabel + '/contacto'
        ],
        component: Contact,
        meta: {
            // page: 'contact',
            breadcrumb: [{
                i18n: 'nav.contact',
                name: 'Contact'
            }],
            localeRoutes: {
                en: '/en/contact',
                fr: '/fr/contact',
                es: '/es/contacto'
            }
        }
    },
    {
        name: 'Termsofuse',
        path: '/' + localeLabel + '/terms-of-use',
        alias: [
            '/' + localeLabel + '/conditions-utilisation',
            '/' + localeLabel + '/terminos-de-uso'
        ],
        component: Page,
        meta: {
            page: 'termsofuse',
            breadcrumb: [{
                i18n: 'nav.termsofuse',
                name: 'Termsofuse'
            }],
            localeRoutes: {
                en: '/en/terms-of-use',
                fr: '/fr/conditions-utilisation',
                es: '/es/terminos-de-uso'
            }
        }
    },
    {
        name: 'Privacy',
        path: '/' + localeLabel + '/privacy-policy',
        alias: [
            '/' + localeLabel + '/politique-de-confidentialite',
            '/' + localeLabel + '/politica-de-privacidad'
        ],
        component: Page,
        meta: {
            page: 'privacypolicy',
            breadcrumb: [{
                i18n: 'nav.privacypolicy',
                name: 'Privacy'
            }],
            localeRoutes: {
                en: '/en/privacy-policy',
                fr: '/fr/politique-de-confidentialite',
                es: '/es/politica-de-privacidad'
            }
        }
    },
    {
        name: 'Legal',
        path: '/' + localeLabel + '/legal-notice',
        alias: [
            '/' + localeLabel + '/mentions-legales',
            '/' + localeLabel + '/avisos-legales'
        ],
        component: Page,
        meta: {
            page: 'legalnotice',
            breadcrumb: [{
                i18n: 'nav.legalnotices',
                name: 'Legal'
            }],
            localeRoutes: {
                en: '/en/legal-notice',
                fr: '/fr/mentions-legales',
                es: '/es/avisos-legales'
            }
        }
    },
    {
        name: 'Credits',
        path: '/' + localeLabel + '/credits',
        alias: [
            '/' + localeLabel + '/creditos'
        ],
        component: Page,
        meta: {
            page: 'credits',
            breadcrumb: [{
                i18n: 'nav.credits',
                name: 'Credits'
            }],
            localeRoutes: {
                en: '/en/credits',
                fr: '/fr/credits',
                es: '/es/creditos'
            }
        }
    },
    {
        name: 'Sitemap',
        path: '/' + localeLabel + '/sitemap',
        alias: [
            '/' + localeLabel + '/plan-du-site',
            '/' + localeLabel + '/mapa-del-sitio'
        ],
        component: SitemapPage,
        meta: {
            // page: 'sitemap',
            breadcrumb: [{
                i18n: 'nav.sitemap',
                name: 'Sitemap'
            }],
            localeRoutes: {
                en: '/en/sitemap',
                fr: '/fr/plan-du-site',
                es: '/es/mapa-del-sitio'
            }
        }
    },
    {
        name: 'TechnicalGuide',
        path: '/' + localeLabel + '/technical-guide',
        alias: [
            '/' + localeLabel + '/guide-technique',
            '/' + localeLabel + '/guia-tecnica'
        ],
        component: TechnicalGuide,
        meta: {
            i18n: 'nav.technicalguide',
            breadcrumb: [{
                i18n: 'nav.technicalguide',
                name: 'TechnicalGuide'
            }],
            localeRoutes: {
                en: '/en/technical-guide',
                fr: '/fr/guide-technique',
                es: '/es/guia-tecnica'
            }
        }
    },
    {
        name: 'Preview',
        path: '/' + localeLabel + '/preview/:id',
        component: ProjectPage,
        meta: {
            type: 'project',
            breadcrumb: [{
                query: 'name',
                name: 'Preview'
            }]
        }
    },
    {
        path: "/",
        redirect: '/' + getLocale()
    },
    {
        name: 'PageNotFound',
        path: '/' + localeLabel + '/404',
        component: Page404
    },
    {
        path: "*",
        redirect: {
            name: 'PageNotFound'
        }
    }
]

function getRawLocaleRoute(to) {
    const regexp = pathToRegexp('/:locale/(.*)')
    const locales = Object.keys(to.meta.localeRoutes).reduce((acc, cur) => {
        const lang = regexp.exec(to.meta.localeRoutes[cur])
        if (lang && lang[2]) {
            acc[cur] = `${lang[2]}/`
        } else {
            acc[cur] = ''
        }
        return acc
    }, {})
    return locales
}

function createAlias(slugs, prefixes) {
    const uniques = Object.keys(slugs).reduce((acc, cur, idx) => {
        if (idx > 0 && acc.indexOf(slugs[cur]) === -1) {
            acc.push({
                locale: slugs[cur],
                lang: cur
            })
        }
        return acc
    }, [])
    return uniques.map(({
        locale,
        lang
    }) => {
        return `/${localeLabel}/${prefixes[lang]}${locale}`
    })
}

function createLocaleRoutes(slugs, prefixes) {
    const locales = Object.keys(slugs).reduce((acc, cur) => {
        acc[cur] = `/${cur}/${prefixes[cur]}${slugs[cur]}`
        return acc
    }, {})
    return locales
}

function createRouteData(data) {
    const breadroute = routes.find(_ => _.name === data.breadcrumb)
    const breadRouteExtensions = breadroute.name !== 'Home' ? getRawLocaleRoute(breadroute) : {
        fr: '',
        en: '',
        es: ''
    }
    const lang = Object.keys(data.translatedslug)[0]
    const breadcrumb = breadroute.name !== 'Home' ? breadroute.meta.breadcrumb.slice(0) : []
    breadcrumb.push({
        query: 'translated_title',
        name: data.slug
    })
    const path = `/${localeLabel}/${breadRouteExtensions[lang]}${data.translatedslug[lang]}`
    const alias = createAlias(data.translatedslug, breadRouteExtensions)
    const localeRoutes = createLocaleRoutes(data.translatedslug, breadRouteExtensions)
    return {
        path,
        breadcrumb,
        localeRoutes,
        alias
    }
}

export function buildRoute(custompages) {
    const newRoutes = custompages.map(page => {
        // const alias = createAlias(page.translatedslug)
        // const localeRoutes = createLocaleRoutes(page.translatedslug)
        // const breadcrumb = createBreadcrumb(page.breadcrumb)
        const {
            path,
            breadcrumb,
            localeRoutes,
            alias
        } = createRouteData(page)
        return {
            name: page.linkname,
            path,
            alias,
            component: Page,
            meta: {
                customPage: page.slug,
                breadcrumb,
                localeRoutes
            }
        }
    })
    // console.log(newRoutes);
    // console.log(newRoutes)
    // const newRoutes = [{
    //     name: 'PaperMario',
    //     path: '/' + localeLabel + '/paper-mario',
    //     alias: [
    //         '/' + localeLabel + '/papier-mario',
    //         '/' + localeLabel + '/pepero-mario'
    //     ],
    //     component: Page,
    //     meta: {
    //         customPage: 'papier-mario',
    //         breadcrumb: [{
    //                 i18n: 'nav.about',
    //                 name: 'About'
    //             },
    //             {
    //                 i18n: 'nav.innovation',
    //                 name: 'Innovation'
    //             }
    //         ],
    //         localeRoutes: {
    //             en: '/en/paper-mario',
    //             fr: '/fr/papier-mario',
    //             es: '/es/pepero-mario'
    //         }
    //     }
    // }]
    routes = routes.concat(newRoutes)
    return newRoutes

}